import styled from "styled-components";
import _ from "underscore";
import { Colors } from "../../config/Constants";

interface Props {
  columns: {
    path: string;
    label: string | null;
    key: string | null;
    // eslint-disable-next-line no-empty-pattern
    content: ({}) => Element | null;
  }[];
  data: {}[];
  onRowClick?: (item: any) => void;
  isTableDataLoading?: boolean;
  showHighlight?: boolean;
}

const TableBody = ({
  columns,
  data,
  onRowClick,
  isTableDataLoading,
  showHighlight
}: Props) => {
  const renderCell = (
    item: {},
    column: {
      path: string;
      label: string | null;
      key: string | null;
      // eslint-disable-next-line no-empty-pattern
      content: ({}) => Element | null;
    }
  ): Element | React.ReactNode | null | string | any => {
    if (column.content) return column.content(item);
    return _.get(item, column.path);
  };

  const createKey = (
    item: { [key: string]: string },
    column: {
      path: string;
      label: string | null;
      key: string | null;
      // eslint-disable-next-line no-empty-pattern
      content: ({}) => Element | null;
    }
  ) => {
    return item.id + (column.path || column.key);
  };

  return (
    <>
      {!isTableDataLoading ? (
        <>
          {data.length > 0 ? (
            <StyledTableBody>
              {data?.map((item: { [key: string]: string }, idx: number) => (
                <StyledRow
                  isClickable={onRowClick ? true : false}
                  onClick={() => onRowClick && onRowClick(item)}
                  key={idx}
                  highlight={
                    showHighlight && item?.highlight === "show" ? "show" : ""
                  }
                >
                  {columns?.map(
                    (column: {
                      path: string;
                      label: string | null;
                      key: string | null;
                      // eslint-disable-next-line no-empty-pattern
                      content: ({}) => Element | null;
                    }) => (
                      <td key={createKey(item, column)}>
                        <div>{renderCell(item, column)}</div>
                      </td>
                    )
                  )}
                </StyledRow>
              ))}
            </StyledTableBody>
          ) : (
            <EmptyState>
              <tr>
                <td colSpan={columns.length}>{"No Records Found"}</td>
              </tr>
            </EmptyState>
          )}
        </>
      ) : (
        <EmptyState>
          <tr>
            <td colSpan={columns.length}>{"Loading... "}</td>
          </tr>
        </EmptyState>
      )}
    </>
  );
};

const EmptyState = styled.tbody`
  width: 100%;
  padding: 5rem 0;
  text-align: center;
  > tr > td {
    padding: 5rem 0;
    color: ${Colors.silver};
  }
`;

const StyledTableBody = styled.tbody`
  font-family: "Poppins-Book";
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 1rem;

  > tr > td {
    padding: 0;
  }
  > tr > td > div {
    padding: 1rem;
    font-size: 0.875rem;
    color: ${Colors.eastBay};
    font-weight: 500;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 370px;
  }
  > tr > td:first-child > div {
    padding-left: 2rem;
  }
`;

interface RowProps {
  isClickable: boolean;
  highlight?: string;
}

const StyledRow = styled.tr<RowProps>`
  cursor: ${(props) => (props.isClickable ? "pointer" : "context-menu")};
  background: ${(props) =>
    props.highlight === "show" ? Colors.lightPureRed : "transparent"};
`;

export default TableBody;
